import http from '../../../services/httpService';

import InventoryReasons from '../domain/InventoryReasons'
import InventoryReasonsRepository from '../domain/inventoryReasonsRepository'

export default class RemoteInventoryReasonsRepository extends InventoryReasonsRepository {
  async getAll() {
    try {
      const { data } = await http.get('/unexpected-outflows/reasons')
      console.log(data)
      if (data.success) {
        return data.data.map(reason => InventoryReasons.fromPrimitives(reason))
      }
      throw new Error(data.mensaje || 'Error al obtener los motivos')
    } catch (error) {
      throw new Error(error.message || 'Error al obtener los motivos')
    }
  }
}
